var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDragHandle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 13
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 2.5h16a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2M1 7.5h16a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2M1 12.5h16a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2"
}))));
export { SvgDragHandle as ReactComponent };
export default __webpack_public_path__ + "static/media/drag-handle.985fd871.svg";